var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeartFilled = function SvgHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12 5.297.53-.53v-.002l-.003-.002-.007-.007-.021-.02A4.997 4.997 0 0 0 12 4.328 7.021 7.021 0 0 1 16.111 3c1.487 0 2.972.598 4.081 1.785C21.305 5.975 22 7.715 22 9.937c0 3.317-2.351 6.088-4.607 7.958a22.04 22.04 0 0 1-3.257 2.233c-.47.26-.887.467-1.22.611-.167.072-.321.131-.456.174A1.56 1.56 0 0 1 12 21a1.56 1.56 0 0 1-.46-.087 5.264 5.264 0 0 1-.455-.174c-.334-.144-.752-.35-1.22-.611a22.038 22.038 0 0 1-3.258-2.233C4.351 16.025 2 13.254 2 9.938c0-2.223.695-3.962 1.808-5.153A5.568 5.568 0 0 1 7.888 3 7.021 7.021 0 0 1 12 4.328l-1.05.219c.68.379 1.05.75 1.05.75Z"
  })));
};
export default SvgHeartFilled;